import React from "react";
import "./Sections.scss";

function QA2() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          What inspired you to turn that appreciation for beauty into your
          life’s work? When did you first consider designing jewelry?
        </p>
        <p className="interview__interview__copy">
          As a child, I spent every summer with my grandmother in the
          countryside near Venice. It’s a beautiful area where the houses have
          been built along the banks of the Brenta Riviera. Where nature
          dictates the pace, typical of life in the countryside.
        </p>
        <p className="interview__interview__copy">
          Every day, as I was running around with the other children, I used to
          stop and look at this little workshop—Elsa’s Atelier. Inside, I could
          see colored fabrics, women absorbed in their work, creating fashion,
          pinning and unpinning, sewing and tailoring. It looked like an
          incredible world to me and I was extremely curious. I learned a lot. I
          saw how to create an object from a wish, how to sketch, how to choose
          fabrics and about the harmony of colors and shapes. All of this
          inspired me deeply.
        </p>
        <p className="interview__interview__copy">
          I fell in love, and, as I was very strong-minded, found a way to enter
          this world and become part of it.
        </p>
      </div>
    </section>
  );
}

export default QA2;
